import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ChatEntity } from 'src/app/models/entities/chat.entity';
import { NotificationEntity } from 'src/app/models/entities/notification.entity';
import { TimeSheetEntity } from 'src/app/models/entities/timesheet.entity';
import { UserEntity } from 'src/app/models/entities/user.entity';
import { EditComponent } from 'src/app/pages/timesheet/edit/edit.component';
import { Subscription } from 'rxjs';

import { TimeSheetService } from 'src/app/services/api/timesheet.service';

import { UserService } from 'src/app/services/api/user.service';
import { DateHelperService } from 'src/app/services/dateHelper.service';
import { MenuService } from 'src/app/services/heading-service';
import { ProfileComponent } from '../profile/profile.component';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { BoardService } from 'src/app/services/api/board.service';
import { NotificationService } from 'src/app/services/api/notifications.service';
import { BoardEntity } from 'src/app/models/entities/board.entity';
import { Location } from '@angular/common';
import { UserSettingsService } from 'src/app/services/api/usersetting.service';
import { SidebarService } from 'src/app/services/side-bar.Service';
import { ChatService } from 'src/app/services/api/chat.service';
import { ChatComponent } from '../chat/chat.component';
import { CardService } from 'src/app/services/api/card.service';
import { Utils } from 'src/app/utils';
import { CardEntity } from 'src/app/models/entities/card.entity';
import { PriorityItemsComponent } from '../priority-items/priority-items.component';
import { NotificationsComponent } from '../notifications/notifications.component';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit, OnDestroy {
  public boardId: string | undefined;
  public userLoaded: boolean = false;
  public role: string = 'Access';
  public heading: string = '';
  public searchTerm: string = '';
  public showSearch: boolean = false;
  public showBoards: boolean = false;
  public profile: string | null = '';
  public user!: UserEntity;
  public sideBarExpanded: boolean = false;
  public runningTimers: TimeSheetEntity[] = [];

  public userNotifications: NotificationEntity[] = [];

  public totalNotifcations: number = 0;
  public priorities: CardEntity[] = [];
  public chats: number = 0;
  public previewUserProfile: string | null = null;
  public boards: BoardEntity[] = [];
  public currentBoardKey: string = '';
  public currentBoard: BoardEntity | null = null;
  private userCards: CardEntity | null = null;
  private updateTimersInterval: any;
  private chatSubscription: Subscription | undefined;

  constructor(
    private boardService: BoardService,
    private userService: UserService,
    private menuService: MenuService,
    private timeSheetService: TimeSheetService,
    private dateHelper: DateHelperService,   
    private cdr: ChangeDetectorRef,
    private userSettings: UserSettingsService,
    private chatService: ChatService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public router: Router,
    private location: Location,
    public auth: AngularFireAuth,
    public notifications: NotificationService,
    public sidebarService: SidebarService,
  ) {
    this.profile = localStorage.getItem('profile-image');
    this.menuService.heading$.subscribe((heading) => {
      this.heading = heading;
    });
    this.menuService.showSearch$.subscribe((showSearch) => {
      this.showSearch = showSearch;
    });
    sidebarService.sidebarOpen$.subscribe((open) => {
      this.sideBarExpanded = open;
    }
    );

    this.menuService.priorityItemCount$.subscribe((priorites: CardEntity[]) => {
      this.priorities = priorites;
    }
    );

    this.menuService.showProjects$.subscribe((boardKey) => {
      this.showBoards = boardKey == '' ? false : true;
      this.currentBoardKey = boardKey;
      const sub = this.boardService.getFilteredBoards().subscribe((boards: any) => {
        sub.unsubscribe();
        this.boards = boards.sort((a: any, b: any) => {
          return a.name.localeCompare(b.name);
        });
        
        // Set current board based on key
        if (this.currentBoardKey && this.boards.length > 0) {
          this.currentBoard = this.boards.find(b => b.key === this.currentBoardKey) || null;
        }
      });
    });


  }
  public hide: boolean = false;
  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {
      if (params['openChat']) {
        this.openChatModal();
      }
    }
    );
    this.userService.profileImageChanged$.subscribe((image) => {
      this.previewUserProfile = image;
    });


    this.userService.currentUser$.subscribe((user) => {
      if (user) {

        this.loadTimers(user);
        this.userLoaded = true;

        this.role = this.userService.currentUser.permission;
        this.profile = this.userService.currentUser.profile;
        this.user = this.userService.currentUser;
        this.notifications
          .getUserNotifications(user.key)
          .subscribe((items: any) => {

            this.userNotifications = items.filter((g:any)=>g.type!=='chat');
            this.totalNotifcations = this.userNotifications.length;


          });

        this.chatSubscription = this.chatService.getChatsMentioningUserCount(user.key).subscribe((count) => {
          this.chats = count;
          this.cdr.detectChanges();
        });

       
      }
    });

    this.boardService.selectedBoard$.subscribe((project) => {
      this.boardId = project?.key;
      this.currentBoard = project;
    });



    //hide when scrolled
    // let prevScrollpos = window.pageYOffset;
    // window.onscroll = () => {
    //   let currentScrollPos = window.pageYOffset;
    //   if (currentScrollPos < 20) {
    //     this.hide = false;
    //   } else {
    //     this.hide = true;
    //   }
    //   prevScrollpos = currentScrollPos;
    // };

    this.timeSheetService.timeSheetAdded$.subscribe((added) => {
      if (added) {
        if (this.userService.currentUser) {
          this.loadTimers(this.userService.currentUser);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.chatSubscription) {
      this.chatSubscription.unsubscribe();
    }
  }

  public boardSelected(board: BoardEntity) {
    this.currentBoardKey = board.key;
    this.currentBoard = board;
    
    this.boardService.selectedBoard = board;
    // Keep the tenant in the query string so the address bar stays a shareable link
    const tenantId = this.userService.currentTenantId;
    this.location.replaceState(`/board/${board.key}`, tenantId ? `t=${tenantId}` : '');
    this.menuService.setBoardSelected(this.boardService.selectedBoard);
    this.userSettings.update(this.userService.currentUser.key, 'lastBoard', board.key);
  }

  openChatModal() {
    this.dialog.open(ChatComponent, {
      width: '90vw',
      height: '90vh'
    

    });
  }
  private loadTimers(user: UserEntity) {
    // No need to query directly, use the observable for running timers
    this.timeSheetService.refreshRunningTimers(user.key).subscribe(() => {
      // Subscribe to running timers updates
      this.timeSheetService.runningTimers$.subscribe(timerMap => {
        // Convert the map values to an array
        this.runningTimers = Array.from(timerMap.values());
        this.updateTimers();
      });
    });

    // Update timers every 30 seconds
    this.updateTimersInterval = setInterval(() => {
      this.updateTimers();
    }, 30000);
  }
  totalTime(item: TimeSheetEntity): number {
    // Calculate time difference between start time and now
    const startDate = new Date(item.date);
    const startTime = item.from.split(':');
    startDate.setHours(parseInt(startTime[0], 10), parseInt(startTime[1], 10), 0, 0);
    
    const now = new Date();
    const diffInMilliseconds = now.getTime() - startDate.getTime();
    const minutes = Math.floor(diffInMilliseconds / (1000 * 60));
    
    return minutes;
  }
  formatMinutes(total: number) {
    return this.dateHelper.formatMinutesWithDays(total);
  }
  updateTimers(): void {
    var newTimers: TimeSheetEntity[] = [];
    for (const iterator of this.runningTimers) {
      iterator.total = this.totalTime(iterator);
      newTimers.push(iterator);
    }

    // Trigger change detection to update the UI
    this.cdr.detectChanges();

    setTimeout(() => {
      // Create a deep copy to ensure change detection
      this.runningTimers = newTimers;
      // Trigger change detection again after updating the array
      this.cdr.detectChanges();
    }, 1000);
  }
  clearSearch() {
    this.menuService.clearSearch();
    this.searchTerm = '';
  }
  search() {
    this.menuService.setSearch(this.searchTerm);
  }

  public prioritiesClicked() {
    let dialogRef = this.dialog.open(PriorityItemsComponent, {
      data: {
        priorities: this.priorities,
      },
    });

  }
  public notificationsClicked() {

    let dialogRef = this.dialog.open(NotificationsComponent, {
      data: {
        notifications: this.userNotifications,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.nav) {
        this.boardService.getItem(result.nav.boardKey).ref.get().then((doc) => {
          if (doc.exists) {
            const queryParams: NavigationExtras = {
              queryParams: {
                chat: result.nav.type === 'chat' ? true : false,
                reload: true,
              },
            };
            this.notifications.delete(
              this.user.key,
              result.nav.boardKey,
              result.nav.cardKey
            );
            this.router.navigate(
              ['board', result.nav.boardKey, result.nav.cardKey],
              queryParams
            );
          } else {
            // Board no longer exists — remove the stale notification
            this.notifications.delete(
              this.user.key,
              result.nav.boardKey,
              result.nav.cardKey
            );
            this.userNotifications = this.userNotifications.filter(
              n => n.key !== result.nav.key
            );
            this.totalNotifcations = this.userNotifications.length;
          }
        });
      }
    });
  }
  public profileClicked() {
    let dialogRef = this.dialog.open(ProfileComponent, {
      data: {
        width: '80vw',
        height: '80vh',
        notifications: this.userNotifications,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {



      if (result) {


        if (result.nav) {

          const queryParams: NavigationExtras = {
            queryParams: {
              chat: result?.nav.type === 'chat' ? true : false,
              reload: true,
              // Add more query parameters as needed
            },
          };
          this.notifications.delete(
            this.user.key,
            result.nav.boardKey,
            result.nav.cardKey
          );


          this.router.navigate(
            ['board', result.nav.boardKey, result.nav.cardKey],
            queryParams
          );
        }

        if (result.card) {

          if (this.boardService.selectedBoard?.key === result.card.boardKey) {
            this.menuService.setCardSelected(result.card);

          } else {

            this.boardService.getItem(result.card.boardKey).ref.get().then((doc) => {
              //not on the board screen
              if (!this.boardService.selectedBoard) {
                this.boardService.selectedBoard = doc.data() as BoardEntity;
                this.router.navigate(
                  ['board', result.card.boardKey, result.card.key]

                ).then(() => {
                  this.boardService.selectedBoard = doc.data() as BoardEntity;
                  this.menuService.setCardSelected(result.card);
                });
              } else {
                this.boardService.selectedBoard = doc.data() as BoardEntity;
                this.menuService.setBoardSelected(doc.data() as BoardEntity);
                const sub = this.menuService.boardItemsLoaded$.subscribe((loaded) => {
                  this.menuService.setCardSelected(result.card);
                  sub.unsubscribe();
                })

              }
            });
          }
        }

      }
    });
  }
  public editItem(item: TimeSheetEntity | null) {
    // this.project = this.data.project;
    // this.cardKey = this.data.cardKey;
    // this.userKey = this.data.userKey;
    // this.item = this.data.item;

    

    const dialogRef = this.dialog.open(EditComponent, {
      data: {
        item: item,
        calendarIdsForDay: [],
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      
      
    });
  }

}
